import React from 'react';
import { translate, SelectInput } from 'react-admin';

import { businessSegments } from '../segments/data';

const SegmentsInput = ({ translate, ...rest }) => (
  <SelectInput
    {...rest}
    choices={businessSegments.map(segment => ({
      id: segment.id,
      name: segment.name
    }))}
  />
);

SegmentsInput.defaultProps = {
  source: 'business_types'
};

export default SegmentsInput;



// WEBPACK FOOTER //
// ./src/business/SegmentsInput.js